import { render, staticRenderFns } from "./ChangeOrderInfo.vue?vue&type=template&id=2fd8c891"
import script from "./ChangeOrderInfo.vue?vue&type=script&lang=js"
export * from "./ChangeOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./ChangeOrderInfo.vue?vue&type=style&index=0&id=2fd8c891&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports